export default "__VITE_ASSET__dpa9Af1R__"